import React from 'react';
import AnimationControlsContainer from '../../AnimationControlsContainer';
import ActiveLineScrollAnimationActiveLineColorSelector from './ActiveLineScrollAnimationActiveLineColorSelector';
import ActiveLineScrollAnimationBackgroundSelector from './ActiveLineScrollAnimationBackgroundSelector';
import ActiveLineScrollAnimationFutureLineColorSelector from './ActiveLineScrollAnimationFutureLineColorSelector';

export interface ActiveLineScrollAnimationControlsProps {}

const ActiveLineScrollAnimationControls: React.FC<ActiveLineScrollAnimationControlsProps> = () => {
  return (
    <AnimationControlsContainer>
      <ActiveLineScrollAnimationActiveLineColorSelector />

      <ActiveLineScrollAnimationFutureLineColorSelector />

      <ActiveLineScrollAnimationBackgroundSelector />
    </AnimationControlsContainer>
  );
};

export default ActiveLineScrollAnimationControls;
